import React, { useContext } from "react";
import Link from "../../utils/Link";
import Features from "../Features";
import { useTranslation } from "react-i18next";
import { LanguageContext, text } from "../../container/language";
import Tags from "../Tags";

const Card = ({
  tags,
  cardTitle,
  cardSubtitle,
  cardFeatures,
  route,
  cardImage,
  index,
  onNextClick,
  onPrevClick,
  active,
  maxIndex,
  contactless,
}) => {
  const { userLanguage } = useContext(LanguageContext);
  const onClick = (e) => {
    if (index === maxIndex && active === 0) {
      onPrevClick();
    } else if (index === 0 && active === maxIndex) {
      onNextClick();
    } else if (index < active) {
      onPrevClick();
    } else if (index > active) {
      onNextClick();
    } else {
      return;
    }
  };

  const Card = () => (
    <div className="card-item__text">
      <Tags data={tags} />
      <div className="card-item__title">
        <p>
          <font>
            <font>{cardTitle}</font>
          </font>
          {contactless && (
            <i class="icon i-PayPass-PayWave" style={{ marginLeft: "5px" }}></i>
          )}
        </p>
        <p>
          <span className="card-item__type">
            <font>
              <font>{text(cardSubtitle, userLanguage)}</font>
            </font>
          </span>
        </p>
      </div>
      <div className="card-item__preview">
        <img src={cardImage} alt="" />
      </div>
      <Features data={cardFeatures} wrapperProps={{}} />
    </div>
  );

  return (
    <div
      className="cards-slider__item"
      id={`credit-card-${index}`}
      style={{ width: "100%", display: "inline-block" }}
    >
      <div className="card-item">
        {route ? (
          <Link draggable="false" to={route} className="card-item__link">
            <Card />
          </Link>
        ) : (
          <Card />
        )}
        <div className="card-item-preview" onClick={onClick}>
          <img src={cardImage} alt="" />
        </div>
      </div>
    </div>
  );
};

export default Card;
